import { defineStore } from 'pinia'

interface State {
  showLocaleModal: boolean
}

export const useLocalModalStore = defineStore('localeModal', {
  state: (): State => ({
    showLocaleModal: false,
  }),
})
